'use client'

import { usePathname } from 'next/navigation'
import Header from '@/components/Header'
import { Footer } from '@/components/Footer'

export default function NavigationContainer({
  children,
}: {
  children: React.ReactNode
}) {
  const pathname = usePathname()
  const isStudioRoute =
    pathname?.startsWith('/studio') ||
    pathname?.startsWith('/structure') ||
    pathname?.startsWith('/vision') ||
    pathname?.startsWith('/presentation')

  return (
    <>
      {!isStudioRoute && <Header />}

      <div
        className={`flex ${
          !isStudioRoute ? 'min-h-[calc(100vh-4rem)]' : 'min-h-screen'
        } flex-col`}
      >
        {children}
      </div>

      {!isStudioRoute && <Footer />}
    </>
  )
}
